var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"personal"},[_c('DropDownMenu'),(_vm.isAuthorized)?_c('NotificationsButton'):_vm._e(),(_vm.isAuthorized)?_c('CartBlock'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }